
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('text',{attrs:{"font-family":"HelveticaNeue-Bold, Helvetica Neue","font-size":"10","font-weight":"bold","letter-spacing":".125"}},[_c('tspan',{attrs:{"x":"7","y":"19"}},[_vm._v("15")])]),_c('path',{attrs:{"d":"M13.933 4H5a5 5 0 00-5 5v3a5 5 0 005 5h1.166v-2H5a3 3 0 01-3-3V9a3 3 0 013-3h8.933v4L19 5l-5.067-5v4z"}})])
      }
    
      }
    